(function(root,factory){
 const api=factory();
 if(typeof module==='object'&&module.exports)module.exports=api;
 else root.MidnightMeasurements=api;
 if(typeof document==='undefined')return;
 function start(){
  document.querySelectorAll('[data-measurements]').forEach(group=>{
   api.sync(group);
   group.querySelector('[data-measurement-units]').addEventListener('change',()=>api.sync(group));
   const form=group.closest('form');
   if(form)form.addEventListener('submit',event=>{try{api.read(group);}catch(error){event.preventDefault();const invalid=Array.from(group.querySelectorAll('input')).find(input=>!input.checkValidity());invalid?.reportValidity();}});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})(typeof window==='undefined'?globalThis:window,function(){
 'use strict';
 const labels={bust:'Bust',waist:'Waist',hips:'Hips'};
 function normalize(input){
  if(input==null)return undefined;
  if(typeof input!=='object'||Array.isArray(input))throw new Error('Enter your measurements using numbers.');
  const values={};
  for(const key of Object.keys(labels)){
   const value=input[key];
   if(value==null||value==='')continue;
   if(typeof value!=='number'&&typeof value!=='string')throw new Error(`Enter a valid ${key} measurement.`);
   if(typeof value==='string'&&!/^(?:\d+(?:\.\d+)?|\.\d+)$/.test(value.trim()))throw new Error(`Enter a number for ${key}.`);
   const number=Number(value);
   if(!Number.isFinite(number)||number<0.01)throw new Error(`Enter a measurement of at least 0.01 for ${key}.`);
   values[key]=number;
  }
  if(!Object.keys(values).length)return undefined;
  if(!['in','cm'].includes(input.units))throw new Error('Choose inches or centimeters.');
  return {units:input.units,...values};
 }
 function format(input){const m=normalize(input);return m?Object.entries(labels).filter(([key])=>m[key]!=null).map(([key,label])=>`${label}: ${m[key]} ${m.units}`).join(' · '):'';}
 function read(group){
  const values={units:group.querySelector('[data-measurement-units]').value};
  group.querySelectorAll('[data-measurement]').forEach(input=>{if(!input.checkValidity())throw new Error(`Enter a positive number for ${input.dataset.measurement}.`);values[input.dataset.measurement]=input.value;});
  return normalize(values);
 }
 function sync(group){
  const unit=group.querySelector('[data-measurement-units]').value;
  group.querySelectorAll('[data-measurement]').forEach(input=>{input.name=`properties[${labels[input.dataset.measurement]} (${unit})]`;});
  group.querySelectorAll('[data-measurement-unit-label]').forEach(label=>{label.textContent=unit;});
 }
 function write(group,input){
  const m=normalize(input);
  group.querySelector('[data-measurement-units]').value=m?.units||input?.units||'in';
  group.querySelectorAll('[data-measurement]').forEach(field=>{field.value=m?.[field.dataset.measurement]??'';});
  sync(group);return m;
 }
 return {normalize,format,read,write,sync};
});
